import currency from 'currency.js';
import { DEFAULT_PRECISION } from '@/utils/produto-utils';

// Define a constante para o número de dias em um mês
// Considerando 30 dias como padrão para simplificação
const DIAS_POR_MES = 30;

function currencyDP(produto, precisao = DEFAULT_PRECISION) {
  return currency(produto, { precision: precisao });
}

function calculaTaxa(prazoDias, valorParcela, taxaFinanceira) {
  const meses = currencyDP(prazoDias).divide(DIAS_POR_MES).value;
  return currencyDP(valorParcela).multiply(currencyDP(1).add(taxaFinanceira).value ** meses).value;
}

function calculateTaxa(prazoPagamento, valor, taxa) {
  if (!prazoPagamento || !valor || !taxa) {
    return 0;
  }
  const prazos = prazoPagamento.descricao.split('/').map(str => Number(str));
  const valorParcela = currencyDP(valor).divide(prazos.length);

  return prazos
    .map(prazoDias => calculaTaxa(prazoDias, valorParcela.value, currencyDP(taxa).value))
    .reduce((acc, val) => acc + val, 0);
}

export {
  // eslint-disable-next-line import/prefer-default-export
  calculateTaxa,
};
